import React from 'react'
import ReactDOM from 'react-dom'
import './styles/App.css'
import { Root } from './components'
import registerServiceWorker from './registerServiceWorker'

ReactDOM.render(<Root />, document.getElementById('root'))
// TODO: Enable before production deployment
// registerServiceWorker();
